import React from 'react';
import TutorialModal from '../TutorialModal/TutorialModal';
import {FINAL_ROUND} from '../../../configs/game';
import {CONSTRUCTIONS_COLOR, SUPPLY_COLOR, WAR_COLOR, WIN_POINTS_COLOR_DARK} from '../../../styles/constants';
import {MINUS_SIGN} from "../../../constants/text";
import {addClassNameIfTrue} from "../../../utils/other/addClassNameIfTrue";
import {
  TutorialDamageDice,
  TutorialDamageDiceFaces,
} from "../TutorialDamageDice/TutorialDamageDice";

/**
 * Обучающие модалки главы 1. Каждая — маленький компонент на базе
 * TutorialModal; идентификаторы (ключи реестра) — в tutorialModalsRegistry.
 * Инфографика — те же иконки, что в правилах, ВСЕГДА с поясняющим текстом.
 */

// icon — произвольный узел вместо картинки src (например, PlayerFactionIcon)
// Типы отрядов для обучающей таблицы: все, кроме катапульт — они появляются
// только в главе 3, и в первой главе лишь запутали бы
// const TUTORIAL_UNIT_TYPES = Object.values(UNIT_TYPES).filter(
//   (unitType) => unitType.id !== UNIT_TYPES.D4.id
// );

export const LegendRow = ({src, label, isUnitIcon, icon, iconBoxClassName}) => (
  <div className={'tutorial-modal_legend-row'}>
    <div className={`tutorial-modal_legend-icon-box ${iconBoxClassName}`}>
      {icon || (
        <img
          className={`tutorial-modal_legend-icon${isUnitIcon ? ' tutorial-modal_legend-icon_unit' : ''}`}
          src={src}
          alt={''}
          aria-hidden={'true'}
        />
      )}
    </div>
    <span>{label}</span>
  </div>
);

// Маленькая иконка-жетон прямо в строке текста (как в страницах правил)
export const InlineTokenIcon = ({src, alt, className, isUnitIcon}) => (
  <img
    className={`policy-description-icon-building tutorial-inline-token-icon ${className} ${addClassNameIfTrue(isUnitIcon, 'tutorial-modal_inline-unit-icon')}`}
    src={src}
    alt={alt}
    title={alt}
  />
);

// Заголовок модалки «Фаза такая-то»: иконка фазы слева + текст цвета фазы
// (иконки и цвета — те же, что у секций правил)
const PhaseTitle = ({iconSrc, color, children}) => (
  <>
    <img
      className={'tutorial-modal_title-icon'}
      src={iconSrc}
      alt={''}
      aria-hidden={'true'}
    />
    <span style={{color}}>{children}</span>
  </>
);

export const Ch1WelcomeModal = () => (
  <TutorialModal title={'Добро пожаловать в Стратегикон!'} buttonText={'Начать обучение'}>
    <p>
      Это первая глава обучения.
      <br/>Здесь ты освоишь базовые правила: строительство, найм отрядов, снабжение, бой и захват
      городов.
    </p>
    <LegendRow
      src={'/img/icons/win points.png'}
      label={<>
        <span className={'text-win-points-dark'}>Победные очки</span> — определяют победителя матча, а также размер
        награды каждого участника.
      </>}
    />
    <LegendRow
      src={'/img/icons/coins.png'}
      label={<>
        <span className={'text-coins-dark'}>Монеты</span> — единственный ресурс в игре: используются для строительства,
        найма отрядов и покупки политик.
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={'Следуй заданиям на плашке справа вверху. А большая стрелка покажет, где выполнить действие.'}
    />
  </TutorialModal>
);

export const Ch1SetupQuarterModal = () => (
  <TutorialModal title={'Стартовый квартал'}>
    <p>
      Каждый матч начинается с размещения <span
      className={'text-construction'}
    >Центрального квартала</span><InlineTokenIcon
      src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
    /> —
      сердца твоего <span className={'text-construction'}>первого</span> города<InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    />. Его можно ставить только на ячейку с флагом <InlineTokenIcon
      src={'/img/icons/flag.png'} alt={'Флаг'}
    /> твоего
      цвета.
    </p>
    <LegendRow
      src={'/img/icons/central quarter.7dd51bfd.png'} label={<>
      <span className={'text-construction'}>Центральный квартал</span> — основа и центр каждого города <InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    />.
    </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Размести <span className={'text-construction'}>Центральный квартал</span><InlineTokenIcon
        src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
      /> на ячейке с флагом, на которую указывает подсказка.
      </>}
    />
  </TutorialModal>
);

export const Ch1RoundPhasesModal = () => (
  <TutorialModal title={'Фазы раунда'}>
    <p>Каждый раунд состоит из трёх фаз, которые игроки проходят по очереди:</p>
    <LegendRow
      src={'/img/icons/supply.png'} label={<>
      <span style={{color: SUPPLY_COLOR}}>Фаза Снабжения</span> — кормим отряды с ферм.
      <InlineTokenIcon src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}/>
    </>}
    />
    <LegendRow
      src={'/img/icons/hammer brown.png'} label={<>
      <span style={{color: CONSTRUCTIONS_COLOR}}>Фаза Строительства</span> — развиваем города.
      <InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/>
    </>}
    />
    <LegendRow
      src={'/img/icons/barracks red.png'} label={<>
      <span style={{color: WAR_COLOR}}>Фаза Войны</span> — нанимаем, перемещаем отряды и сражаемся!
    </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Отрядов у тебя пока нет.
      <br/>Поэтому перейдем сразу к <span style={{color: CONSTRUCTIONS_COLOR}}>Строительству</span>.
    </>}
    />
  </TutorialModal>
);

export const Ch1ConstructionModal = () => (
  <TutorialModal
    title={
      <PhaseTitle iconSrc={'/img/icons/hammer brown.png'} color={CONSTRUCTIONS_COLOR}>
        Фаза Строительства
      </PhaseTitle>
    }
  >
    <LegendRow
      src={'/img/icons/action.png'} label={
      <>
        В <span className={'text-construction'}>фазе Строительства</span> можно выполнить до 2 действий<InlineTokenIcon
        src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
      />.
        <br/>Но в 1-м раунде для быстрого старта даётся на 2<InlineTokenIcon
        src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
      /> больше — то есть всего 4<InlineTokenIcon
        src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
      />.
      </>
    }
    />
    <LegendRow
      src={'/img/hexes/quarter.f69660fa.png'}
      label={<>
        <span className={'text-construction'}>Базовый квартал</span> — расширяет город<InlineTokenIcon
        src={'/img/icons/city.42008716.png'} alt={'Город'}
      />, строится только вплотную
        (смежно) к <span className={'text-construction'}>Центральному кварталу</span><InlineTokenIcon
        src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
      />.
      </>}
    />
    <LegendRow
      src={'/img/hexes/mine.ecae90cd.png'}
      label={<>
        <span className={'text-coins-dark'}>Рудник</span> — если присоединён к городу<InlineTokenIcon
        src={'/img/icons/city.42008716.png'} alt={'Город'}
      />, приносит <span
        className={'text-coins-dark'}
      >1 монету</span><InlineTokenIcon src={'/img/icons/coins.png'} alt={'Очки'}/> в конце каждого раунда.
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Построй <span className={'text-construction'}>Базовый квартал</span><InlineTokenIcon
        src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
      /> на указанной ячейке: рядом с ней <span
        className={'text-coins-dark'}
      >Рудник</span><InlineTokenIcon src={'/img/hexes/mine.ecae90cd.png'} alt={'Рудник'}/> — он присоединится к
        городу<InlineTokenIcon
        src={'/img/icons/city.42008716.png'} alt={'Город'}
      /> и начнёт приносить доход<InlineTokenIcon
        src={'/img/icons/coins.png'} alt={'Монеты'}
      />.
      </>}
    />
  </TutorialModal>
);

export const Ch1UndoButtonModal = () => (
  <TutorialModal title={'Кнопка отмены действия'}>
    <LegendRow
      src={'/img/icons/return.png'} label={<>
      В правом нижнем углу на нижней панели есть <span className={'text-controls'}>Кнопка отмены действий</span>:
      она позволяет отменить действия текущей фазы —
      стройку, найм отряда, перемещение или снабжение.
    </>}
    />
    <p>
      А ещё действие на ячейке всегда можно <span className={'text-controls'}>отменить</span> быстрым <span
      className={'text-controls'}
    >двойным нажатием</span> на
      эту ячейку — перемещение отрядов, строительство, распределение снабжения и другие.
    </p>
    <p>
      Попробуй сам: <b>отмени</b> только что построенный квартал кнопкой
      отмены, а затем <b>построй его заново</b> на той же ячейке.
    </p>
  </TutorialModal>
);

export const Ch1UndoPhasesModal = () => (
  <TutorialModal title={'Отмена — во всех фазах'}>
    <LegendRow
      src={'/img/icons/return.png'} label={<>
      Кнопка отмены работает <b>во всех фазах</b>, а не только в
      Строительстве: ею можно откатить найм отряда, перемещение и раздачу
      снабжения.
    </>}
    />
    <p>
      Дальше в обучении отмена действий <b>заблокирована</b>, чтобы ты не сбился с
      выверенного сценария.
    </p>
    <p>
      В настоящих матчах отмена доступна всегда, пока ты не завершил свой ход.
    </p>
  </TutorialModal>
);

export const Ch1UnitTypesModal = () => (
  <TutorialModal title={'Отряды'}>
    <LegendRow
      src={'/img/hexes/barracks_active.22121e1f.png'} label={<>
      Новые отряды нанимаются на <b>свободных казармах</b> и появляются с размером <InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={''}
    /> 1.
    </>}
    />

    <LegendRow
      src={'/img/icons/unit size.png'} label={<>
      Размер — это и прочность отряда, и сила, с которой он наносит урон.
    </>}
    />

    <p>
      Типы отрядов различаются максимальным размером<InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    />, скоростью <InlineTokenIcon src={'/img/icons/speed.png'} alt={'Скорость'}/> и ценой<InlineTokenIcon
      src={'/img/icons/coins.png'} alt={'Монеты'}
    />.
    </p>

    {/* Та же таблица, что в правилах («Отряды»), но короче: без катапульт —
        с ними знакомит глава 3 — и без колонок стрельбы и цены размера */}
    {/*<UnitTypesTable*/}
    {/*  unitTypes={TUTORIAL_UNIT_TYPES}*/}
    {/*  showName={true}*/}
    {/*  showSizePrice={false}*/}
    {/*  showShootingRange={false}*/}
    {/*/>*/}

    <LegendRow src={'/img/icons/arrow_down_big.png'} label={'Для начала найми обычную Пехоту на построенной казарме.'}/>
  </TutorialModal>
);

export const Ch1SizeRecruitmentModal = () => (
  <TutorialModal title={'Найм размера'}>
    <p>

    </p>
    <LegendRow
      src={'/img/icons/coins.png'} label={<>
      Отряд, стоящий на казарме<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/>, можно усиливать за
      монеты — это называется <span
      className={'text-war'}
    >найм размера</span>.
      Каждый <span className={'text-construction'}>квартал</span> даёт возможность нанять размер<InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    /> 1 раз за <span
      className={'text-war'}
    >фазу Войны</span>.
    </>}
    />

    <LegendRow
      src={'/img/icons/unit size.png'} label={<>
      Размер отряда — это и его прочность, и сила, с которой он наносит урон.
      <br/>Текущий размер отряда указан под иконкой отряда на поле. А также в нижней панели, если
      выбрана ячейка с отрядом.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Нажми на свой отряд<InlineTokenIcon
        src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
      />, затем на подсвеченные <span className={'text-construction'}>кварталы</span> — докупи размер<InlineTokenIcon
        src={'/img/icons/unit size.png'} alt={'Размер отряда'}
      /> дважды.
      </>}
    />
  </TutorialModal>
);

export const Ch1SupplyModal = () => (
  <TutorialModal title={'Снабжение отрядов'}>
    <p>
      Каждую <span className={'text-supply'}>фазу Снабжения</span> фермы<InlineTokenIcon
      src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}
    /> «кормят» отряды.
      <br/>Отряд <span className={'text-war'}>без снабжения теряет 2 размера</span><InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    />.
      <br/>А <span className={'text-supply'}>снабжённый растёт</span>:
      <br/>• +2<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> на казарме<InlineTokenIcon
      src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}
    />.
      <br/>• +1<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> на любой другой ячейке.
    </p>
    <LegendRow
      src={'/img/hexes/farm.699e6dfc.png'}
      label={<>
        Ферма — производит одну единицу снабжения за раунд: может прокормить 1 отряд.
      </>}
    />
    <LegendRow
      src={'/img/icons/supply.png'} label={<>
      Снабжение — доставляется на дальность <span className={'text-supply'}>до 5 ячеек</span>
      <br/>от фермы<InlineTokenIcon
      src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}
    />.
    </>}
    />
    <p>

    </p>
    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Нажми на ферму<InlineTokenIcon src={'/img/hexes/farm 1_1.3a45c526.png'} alt={'Ферма'}/>, затем на отряд<InlineTokenIcon
        src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
      /> — передай ему снабжение<InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/>.
      </>}
    />
    <p>
      <i>Только в обучении мы просим распределять снабжение вручную: в настоящих матчах
        снабжение раздаётся автоматически — от тебя нужны лишь подтверждение или
        точечные корректировки.</i>
    </p>
  </TutorialModal>
);

// Второй паёк отряду перед боем Р2 — только про переброс костей: остальные
// способы потратить дополнительное снабжение — в главе 3
export const Ch1AdditionalSupplyModal = () => (
  <TutorialModal title={'Дополнительное снабжение'}>
    <LegendRow
      src={'/img/icons/supply.png'}
      label={<>
        Отряд можно <span className={'text-supply'}>снабдить</span> с ферм<InlineTokenIcon
        src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}
      /> <span className={'text-supply'}>дважды</span> за одну <span className={'text-supply'}>фазу Снабжения</span>:
        <br/>• Первый паёк — <span className={'text-supply'}>базовое снабжение</span><InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      />: за него отряд растёт размером<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
        <br/>• Второй паёк — <span className={'text-supply'}>дополнительное снабжение</span><InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      />: размер<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> не растёт, но <InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      /> остаётся у отряда <span className={'text-war'}>до конца раунда</span> (или пока не будет потрачено).
      </>}
    />
    <LegendRow
      src={'/img/icons/barracks red.png'}
      label={<>
        В этом раунде твой отряд<InlineTokenIcon
        src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
      /> вступит в <span className={'text-war'}>ближний бой</span> — <span className={'text-supply'}>дополнительное снабжение</span><InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      /> пригодится!
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Первый паёк отряд уже получил. Дай ему второй — с другой фермы<InlineTokenIcon
        src={'/img/hexes/farm 1_1.3a45c526.png'} alt={'Ферма'}
      />.
      </>}
    />
  </TutorialModal>
);

// Переброс в бою с нейтралом: через 3 с после изучения обоих отрядов
export const Ch1RerollModal = () => (
  <TutorialModal title={'Переброс костей'}>
    <LegendRow
      icon={<TutorialDamageDice isSpinning={true}/>}
      label={<>
        Твой отряд<InlineTokenIcon
        src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
      /> выбросил плохой результат: <TutorialDamageDice value={-2} isInline={true}/> и <TutorialDamageDice
        value={-2} isInline={true}
      />.
        <br/>Итоговый урон = <InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>6
        + <TutorialDamageDice value={-2} isInline={true}/> + <TutorialDamageDice value={-2} isInline={true}/> = <span
        className={'text-war'}
      >2</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      /> — нейтральный отряд выживет.
      </>}
    />
    <LegendRow
      src={'/img/icons/supply.png'}
      label={<>
        Но у твоего отряда есть <span className={'text-supply'}>дополнительное снабжение</span><InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      /> — в
        фазе Снабжения он получил 2 пайка. За него можно <span
        className={'text-war'}
      >перебросить кости урона</span>{' '}<TutorialDamageDice value={-2} isInline={true}/>!
      </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'}
      label={<>
        Благодаря усиленному снабжению отряды с большей вероятностью подерутся хорошо: неудачный бросок можно исправить.
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Нажми на свой отряд<InlineTokenIcon
        src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
      />, выбери ОБЕ <span className={'text-war'}>кости</span>{' '}<TutorialDamageDice
        value={-2} isInline={true}
      /> и нажми «Перебросить».
      </>}
    />
  </TutorialModal>
);

export const Ch1WinPointsModal = () => (
  <TutorialModal title={'Победные очки'}>
    <LegendRow
      src={'/img/icons/first place.png'} label={
      <>
        Напомню:
        <br/>• В матче побеждает игрок с наибольшим количеством <span
        className={'text-win-points-dark'}
      >очков</span><InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      /> за {FINAL_ROUND} раундов.
        <br/>• В конце матча оставшиеся <span className={'text-coins-dark'}>монеты</span><InlineTokenIcon
        src={'/img/icons/coins.png'} alt={'Монеты'}
      /> обменяются на <span className={'text-win-points-dark'}>очки</span><InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      /> по курсу <span className={'text-coins-dark'}>2</span> к <span className={'text-win-points-dark'}>1</span>.
      </>
    }
    />
    <LegendRow
      src={'/img/hexes/ruins.65862e11.png'} label={
      <>
        <span className={'text-win-points-dark'}>Руины</span> — 2 очка<InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      /> в конце каждого раунда, если присоединены к городу.
      </>
    }
    />
    <LegendRow
      src={'/img/hexes/super_ruins.97515170.png'} label={
      <>
        <span className={'text-win-points-dark'}>Великие руины</span> — 4 очка<InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      />, аналогично.
      </>
    }
    />
    {/*<LegendRow
      src={'/img/icons/exclamation-mark.png'} label={
      <>
        <span className={'text-war'}>В последних {ROUNDS_WITH_RUINS_INCREASED_INCOME} раундах</span> Руины
        приносят <span className={'text-war'}>удвоенное</span> количество очков<InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      />.
      </>
    }
    />*/}

    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Построй <span className={'text-construction'}>Базовый квартал</span><InlineTokenIcon
        src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
      /> на указанной ячейке, чтобы присоединить Руины к своему городу<InlineTokenIcon
        src={'/img/icons/city.42008716.png'} alt={'Город'}
      />. Ты получишь <span style={{color: WIN_POINTS_COLOR_DARK}}>1</span><InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      /> за их
        захват. И Руины начнут приносить тебе <span style={{color: WIN_POINTS_COLOR_DARK}}>2</span><InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      /> в конце каждого
        раунда.
      </>}
    />
  </TutorialModal>
);

export const Ch1MovementModal = () => (
  <TutorialModal title={'Перемещение отрядов'}>
    <p>
      На этапе перемещения можно переместить каждый свой отряд.
    </p>
    <LegendRow
      src={'/img/icons/speed.png'} label={
      <>
        Скорость — сколько ячеек отряд может пройти за ход.
        <br/><br/>У пехоты<InlineTokenIcon
        src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
      /><InlineTokenIcon
        src={'/img/icons/unit d10 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая пехота'}
      /><InlineTokenIcon
        src={'/img/icons/unit d20 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Элитная пехота'}
      /> скорость = 2.
        <br/><br/>У кавалерии<InlineTokenIcon
        src={'/img/icons/unit d8 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Лёгкая кавалерия'}
      /><InlineTokenIcon
        src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
      /> скорость = 4.
      </>
    }
    />
    <p>
    </p>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Нажми на отряд<InlineTokenIcon
        src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
      />, затем на подсвеченную ячейку, чтобы передвинуть его вплотную к нейтральному отряду, охраняющему нейтральный
        город в центре.
      </>}
    />
  </TutorialModal>
);

export const Ch1MeleeRulesModal = () => (
  <TutorialModal title={'Ближний бой'}>
    <p>
    </p>
    <LegendRow
      src={'/img/icons/barracks red.png'} label={
      <>
        Отряды, стоящие вплотную к противнику, вступают в <span
        className={'text-war'}
      >Ближний бой</span>.
      </>
    }
    />
    <p>
      Урон, который отряд нанесёт противнику, считается так:
    </p>
    <LegendRow
      src={'/img/icons/damage.png'} label={
      <>
        Урон = размер<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> отряда + сумма бросков
        2-х <span className={'text-war'}>костей урона</span>{' '}<TutorialDamageDice value={0} isInline={true}/>.
      </>
    }
    />
    <LegendRow
      icon={<TutorialDamageDice isSpinning={true}/>} label={<>
      <span className={'text-war'}>Кость урона</span> — это кубик с гранями:
      <TutorialDamageDiceFaces/>
      <span className={'text-war'}>Средний результат</span> броска такой кости — около <span
      className={'text-war'}
    >{MINUS_SIGN}1</span>.
    </>}
    />
    <p>
      Урон наносится <b>одновременно</b>: оба отряда теряют размер<InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    />, равный
      полученному урону<InlineTokenIcon src={'/img/icons/damage.png'} alt={'Урон'}/>. Отряд с размером<InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    />0 уничтожается.
    </p>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Заверши этап Перемещения<InlineTokenIcon
        src={'/img/icons/speed.png'} alt={'Перемещение'}
      /> — начнётся Ближний бой<InlineTokenIcon
        src={'/img/icons/barracks red.png'} alt={'Ближний бой'}
      /> с нейтральным отрядом.
      </>}
    />
  </TutorialModal>
);

export const Ch1CombatResultsModal = () => (
  <TutorialModal title={'Результаты ближнего боя'}>
    <p>
      Твой отряд с размером<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>6 выбросил на <span
      className={'text-war'}
    >костях урона</span>
      <br/><TutorialDamageDice value={-2} isInline={true}/> и <TutorialDamageDice value={-2} isInline={true}/>.
      <br/>Итого он нанесёт всего <span className={'text-war'}>2 урона</span><InlineTokenIcon
      src={'/img/icons/damage.png'} alt={'Урон'}
    /> — нейтральный
      отряд с размером<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> 6 такой удар переживёт.
    </p>
    <p>
      Нейтральному отряду повезло больше: он выбросил на <span className={'text-war'}>костях урона</span>{' '}
      <TutorialDamageDice value={-3} isInline={true}/> и <TutorialDamageDice value={0} isInline={true}/>.
      <br/>Нейтральный отряд тоже имеет размер<InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    /> 6 и нанесёт <span className={'text-war'}>3 урона</span><InlineTokenIcon
      src={'/img/icons/damage.png'} alt={'Урон'}
    />.
      Значит, размер<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> твоего
      отряда<InlineTokenIcon
      src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
    /> упадёт на 3 и станет равен 3<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
    </p>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Нажми на каждый отряд и ознакомься с результатами <span
        className={'text-war'}
      >Ближнего боя</span><InlineTokenIcon src={'/img/icons/barracks red.png'} alt={'Ближний бой'}/> — расчёт урона
        показывается в панели снизу.
      </>}
    />
  </TutorialModal>
);

export const Ch1CityCaptureModal = () => (
  <TutorialModal title={'Захват города'}>
    <p>
      Город переходит к тебе, если в конце раунда твой отряд стоит на его <span
      className={'text-construction'}
    >квартале</span>, а отрядов владельца на <span className={'text-construction'}>кварталах</span> города нет.
    </p>
    <LegendRow
      src={'/img/icons/city.42008716.png'} label={<>
      Город = <span className={'text-construction'}>Центральный квартал</span><InlineTokenIcon
      src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
    /> + смежные <span
      className={'text-construction'}
    >Базовые кварталы</span><InlineTokenIcon
      src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
    /> + присоединённые к ним фермы<InlineTokenIcon
      src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}
    />, казармы <InlineTokenIcon
      src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}
    /> и ключевые точки <InlineTokenIcon
      src={'/img/hexes/key point.1479d53f.png'} alt={'Любая ключевая точка'}
    />.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'}
      label={<>
        Защитник города<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/> уничтожен — заверши этап Найма,
        затем передвинь отряд на <span className={'text-construction'}>Центральный квартал</span> нейтрального
        города<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/>.
      </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'}
      label={<>
        В настоящем матче для захвата города<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/> подойдёт любой:
        и <span className={'text-construction'}>Центральный</span><InlineTokenIcon
        src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
      />, и <span className={'text-construction'}>Базовый квартал</span><InlineTokenIcon
        src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
      />.
      </>}
    />
  </TutorialModal>
);

export const Ch1BaseIncomeModal = () => (
  <TutorialModal title={'Доход города'}>
    <LegendRow
      src={'/img/icons/coins.png'}
      label={<>
        Сейчас твой доход — <span className={'text-coins-dark'}>+2 монеты</span><InlineTokenIcon
        src={'/img/icons/coins.png'} alt={'Монеты'}
      />. Это <span className={'text-coins-dark'}>базовый доход</span>: его
        получает каждый игрок, который имеет хотя бы 1 город<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/>.
      </>}
    />
    <LegendRow
      src={'/img/hexes/mine.ecae90cd.png'}
      label={<>
        <span className={'text-coins-dark'}>Рудник</span> присоединился к городу<InlineTokenIcon
        src={'/img/icons/city.42008716.png'} alt={'Город'}
      />.
        <br/>Он добавит <span className={'text-coins-dark'}>+1</span><InlineTokenIcon
        src={'/img/icons/coins.png'} alt={'Монеты'}
      /> к доходу — всего станет <span
        className={'text-coins-dark'}
      >+3</span><InlineTokenIcon
        src={'/img/icons/coins.png'} alt={'Монеты'}
      />.
      </>}
    />
    <p>
      Новое значение дохода отобразится только после завершения <span className={'text-construction'}>фазы
      Строительства</span> — когда ты подтвердишь свои действия<InlineTokenIcon
      src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
    />.
    </p>

    <LegendRow
      src={'/img/icons/exclamation-mark.png'}
      label={<>
        За каждый присоединённый <span className={'text-coins-dark'}>Рудник</span> или <span
        className={'text-win-points-dark'}
      >Руины</span> ты также получаешь по <span
        className={'text-win-points-dark'}
      >1 победному очку</span><InlineTokenIcon src={'/img/icons/win points.png'} alt={'Очки'}/> единовременно, когда
        завершаешь <span className={'text-construction'}>фазу Строительства</span>.
      </>}
    />
  </TutorialModal>
);

export const Ch1MeleeDamageModal = () => (
  <TutorialModal title={'Урон в ближнем бою'}>
    <LegendRow
      icon={<TutorialDamageDice isSpinning={true}/>}
      label={<>
        После переброса урон = <InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>6
        + <TutorialDamageDice value={0} isInline={true}/> + <TutorialDamageDice value={0} isInline={true}/> = <span
        className={'text-war'}
      >6</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      /> — нейтральный отряд будет уничтожен. И после этапа <span className={'text-war'}>Ближнего боя</span> ты
        получишь <span
        className={'text-win-points-dark'}
      >очки</span><InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      /> (чем лучше тип уничтоженного отряда, тем их больше).
      </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'}
      label={<>
        В среднем отряд наносит <span className={'text-war'}>на 2<InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      /> меньше</span>, чем его размер: в лучшем случае —
        столько же, в худшем — на 6 меньше. Учитывай это в настоящих матчах.
      </>}
    />
    <p>
      Мудрый стратег не только наращивает силы с запасом, но и умеет поймать момент, когда стоит
      понадеяться на удачу.
    </p>
    <p>
      В главе 3 Обучения мы расскажем про политики и другие способы потратить дополнительное снабжение — они тоже
      помогут не полагаться на удачу в бою.
    </p>
  </TutorialModal>
);

export const Ch1WarPhaseModal = () => (
  <TutorialModal
    title={
      <PhaseTitle iconSrc={'/img/icons/barracks red.png'} color={WAR_COLOR}>
        Фаза Войны
      </PhaseTitle>
    }
  >
    <p>
      Все игроки завершили <span className={'text-construction'}>фазу Строительства</span> — начинается <span
      className={'text-war'}
    >фаза Войны</span>.
    </p>
    <p>
      Каждый игрок выполняет свою <span className={'text-war'}>фазу Войны</span> полностью.
      <br/>И только потом передает ход следующему игроку.
    </p>
    <p>
      <span className={'text-war'}>Фаза Войны</span> состоит из 5 этапов:
    </p>
    <LegendRow
      src={'/img/icons/coins.png'}
      label={<b>1. Найм отрядов</b>}
    />
    <LegendRow
      src={'/img/icons/speed.png'}
      label={<b>2. Перемещение</b>}
    />
    <LegendRow
      src={'/img/icons/shooting.png'}
      label={<b>3. Стрельба</b>}
    />
    <LegendRow
      src={'/img/icons/barracks red.png'}
      label={<b>4. Ближний бой</b>}
    />
    <LegendRow
      src={'/img/icons/maneuver_black.png'}
      label={<b>5. Манёвр</b>}
    />
    {/*<LegendRow
      src={'/img/icons/coins.png'}
      label={<><b>1. Найм</b> — новые отряды нанимаются на свободных казармах, а с кварталов города
        докупается размер отрядов.</>}
    />
    <LegendRow
      src={'/img/icons/speed.png'}
      label={<><b>2. Перемещение</b> — отряды перемещаются на число ячеек не больше своей скорости.</>}
    />
    <LegendRow
      src={'/img/icons/shooting.png'}
      label={<><b>3. Стрельба</b> — стреляют только катапульты (о них расскажем в 3 главе обучения).</>}
    />
    <LegendRow
      src={'/img/icons/barracks red.png'}
      label={<><b>4. Ближний бой</b> — смежные друг другу отряды игрока и противника одновременно наносят друг другу
        урон.</>}
    />
    <LegendRow
      src={'/img/icons/maneuver_black.png'}
      label={<><b>5. Манёвр</b> — дополнительное перемещение отряда после боя.</>}
    />*/}
  </TutorialModal>
);

export const Ch1WarPhaseButtonModal = () => (
  <TutorialModal title={'Завершение этапов'}>
    <p>
      Каждый этап <span className={'text-war'}>фазы Войны</span> завершается отдельным нажатием <b>кнопки завершения
      хода</b>.
    </p>
    <p>
      В 1-й главе Обучения мы изучим этапы Найма<InlineTokenIcon
      src={'/img/icons/coins.png'} alt={'Монеты'}
    />, Перемещения<InlineTokenIcon
      src={'/img/icons/speed.png'} alt={'Перемещение'}
    /> и Ближнего боя<InlineTokenIcon
      src={'/img/icons/barracks red.png'} alt={'Ближний бой'}
    />.
    </p>
    <p>
      Остальные этапы — Стрельбу<InlineTokenIcon
      src={'/img/icons/shooting.png'} alt={'Стрельба'}
    /> и Манёвр<InlineTokenIcon
      src={'/img/icons/maneuver_black.png'} alt={'Манёвр'}
    /> —
      разберём в 3-ей главе Обучения.
    </p>
  </TutorialModal>
);
